/* eslint-disable */
import React from "react";
import DatePicker from "react-datepicker";
import Form from "react-bootstrap/Form";
import moment from "moment";

const NewAppointment = (props) => {
  return (
    <>
      <section className="as_breadcrum_wrapper" id="appointment">
        <div className="container" data-aos="fade-up" data-aos-delay="200">
          <div className="row">
            <div className="col-lg-12 text-center">
              <h1>Book Appointment</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="as_appointment_wrapper as_padderBottom80" style={{paddingBottom: '150px'}}>
        <form>
          <div className="container" data-aos="fade-up">
            <div className="row">
              <div
                className="col-lg-12"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <h3
                  className="as_heading as_heading_center text-center"
                  style={{ padding: "0" }}
                ></h3>

                <div
                  className="as_journal_box_wrapper"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <div>
                    <h3
                      className="text-center as_subheading"
                      style={{ margin: "40px 0" }}
                    >
                      Make Your Appointment To Discuss Any Problem.
                    </h3>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label>Name</label>
                        <div className="form-group">
                          <input
                            id="name"
                            name="name"
                            className="form-control"
                            placeholder="Name"
                            minLength={3}
                            type="text"
                            value={props.name}
                            onChange={(e) => {
                              props.setName(
                                e.target.value.replace(/[^a-z, ]/gi, "")
                              );
                              if (props.name.length > 2)
                                props.setNamemsg(false);
                            }}
                          />

                          {props.namemsg ? (
                            <p style={{ color: "red" }}>Enter Valid Name</p>
                          ) : null}
                        </div>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label>Mobile number</label>

                        <div className="form-group">
                          <input
                            id="mobile"
                            name="mobile"
                            className="form-control"
                            type="text"
                            maxLength={10}
                            placeholder="Mobile Number"
                            value={props.mobile}
                            onChange={(e) => {
                              props.setMobile(
                                e.target.value.replace(/\D/g, "")
                              );
                              if (props.mobile.length == 9)
                                props.setNumbermsg(false);
                            }}
                          />
                          {props.numbermsg ? (
                            <p style={{ color: "red" }}>
                              Enter Valid Mobile Number
                            </p>
                          ) : null}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <Form>
                          <Form.Group style={{display: 'flex', flexDirection: 'column'}}>
                            <Form.Label>Preferred Date</Form.Label>
                            <DatePicker
                              id="date"
                              name="date"
                              popperPlacement="top"
                              placeholderText="Choose date"
                              selected={props.tempDate}
                              filterDate={(date) => date.getDay() !== 0}
                              onChange={(e) => {
                                props.setTempDate(e);
                                props.setDate(
                                  moment(new Date(e)).format("DD-MM-YYYY")
                                );
                                if (e !== null || e.length > 0)
                                  props.setDatemsg(false);
                              }}
                              className="form-control"
                              minDate={new Date()}
                              type="date"
                              dateFormat="dd-MM-yyyy"
                              placeholder="Select Date"
                            />
                            {props.datemsg ? (
                              <p style={{ color: "red" }}>Please Select Date</p>
                            ) : null}
                          </Form.Group>
                        </Form>
                      </div>

                      <div className="col-lg-6 col-md-6 col-sm-6 col-xs-6">
                        <label>Preferred Time</label>

                        <div className="form-group">
                          <select
                            className="form-control"
                            value={props.start_time}
                            onChange={(e) => {
                              props.setStart_time(e.target.value);
                              if (
                                props.start_time.length > 0 ||
                                props.start_time !== null
                              )
                                props.setTimemsg(false);
                            }}
                          >
                            <option selected disabled value="">
                              Select...
                            </option>
                            {props.displayTime?.map((row) => {
                              return <option>{row}</option>;
                            })}
                          </select>
                          {props.timemsg ? (
                            <p style={{ color: "red" }}>Please Select Time</p>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    {/* <div className="row">
                      <div className="col-lg-12 reason12">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                          <label>Reason of appointment</label>
                          <div className="form-group as_select_box">
                            <select
                              className="form-control"
                              value={props.selected}
                              onChange={(e) => {
                                props.setSelected(e.target.value);
                                if (
                                  props.selected.length > 0 ||
                                  props.selected !== null
                                )
                                  props.setReasonmsg(false);
                              }}
                            >
                              <option selected disabled value="">
                                Choose...
                              </option>
                              {props.category.map((row) => {
                                return <option>{row.name}</option>;
                              })}
                            </select>
                            {props.reasonmsg ? (
                              <p style={{ color: "red" }}>
                                Please Select Category
                              </p>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center as_padderTop50">
                      <button
                        className="as_btn"
                        type="button"
                        onClick={() => props.submitHandler()}
                      >
                        make an appointment
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </section>
    </>
  );
};

export default NewAppointment;
